/**
 * US 37168: a proposed dispatch change sent to the labor-impact preview. EmployeeID left out keeps the
 * dispatch's employee.
 */
export interface LaborImpactRequest {
  employeeJobID: string;
  employeeID?: string | null;
  prGroup?: string | null;
  prDept?: string | null;
}

/** US 37168: one labor line before and after the save; reason is set on a line left alone. */
export interface LaborImpactLine {
  employeeLaborID: string;
  dateWorked: Date | string | null;
  hours: number | null;
  prCoBefore: string | null;
  groupBefore: string | null;
  prDeptBefore: string | null;
  prCoAfter: string | null;
  groupAfter: string | null;
  prDeptAfter: string | null;
  reason: string | null;
}

/** US 37168: an exported line, what it was paid under against the dispatch's new values. */
export interface LaborImpactExportedLine {
  employeeLaborID: string;
  dateWorked: Date | string | null;
  hours: number | null;
  dateExported: Date | string | null;
  weekEndDateExported: Date | string | null;
  paidEmployeeID: string | null;
  paidPRCo: string | null;
  paidGroup: string | null;
  paidPRDept: string | null;
  newEmployeeID: string | null;
  newPRCo: string | null;
  newGroup: string | null;
  newPRDept: string | null;
}

/**
 * US 37168: what saving a dispatch change does to its labor. willMove are the pending lines the save
 * restamps, leftAlone the unexported lines that differ but stay, exported the posted lines of the last
 * 84 days paid under other values. All three are empty when employee, group and dept are unchanged.
 */
export interface LaborImpact {
  employeeJobID: string;
  willMove: LaborImpactLine[];
  leftAlone: LaborImpactLine[];
  exported: LaborImpactExportedLine[];
}
